import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { TYPESOFORDERS } from "../../../contants";
import {
  setOrderType,
  activateOrder,
} from "../../../redux/action/orderActions";
import {
  activateOrderOffline,
  getOfflineLastOrderNumber,
} from "../../../redux/action/offlineDataActions";
import getoffiledata from "../../../helpers/readOfflineData";

const MobileOrderTypeSelector = ({ onSelectType }) => {
  const dispatch = useDispatch();
  const { username } = useSelector((state) => state.user);
  const { isOnline, isAppOffline } = useSelector(
    (state) => state.networkStatus
  );
  const isElectron = window?.api?.isElectron;

  const orderTypes = [
    {
      id: TYPESOFORDERS[0].value,
      label: "DINE IN",
      icon: "mdi mdi-silverware-fork-knife",
      key: TYPESOFORDERS[0].key,
    },
    {
      id: TYPESOFORDERS[1].value,
      label: "PARCEL",
      icon: "mdi mdi-package-variant",
      key: TYPESOFORDERS[1].key,
    },
    {
      id: TYPESOFORDERS[2].value,
      label: "HOME DELIVERY",
      icon: "mdi mdi-bike",
      key: TYPESOFORDERS[2].key,
    },
  ];

  const handleTypeSelect = async (type, index) => {
    // For Dine In (index 0), just set the order type filter
    // For Parcel and Home Delivery, create a new order
    if (index === 0) {
      dispatch(setOrderType(type.id));
    } else {
      if ((isAppOffline || !isOnline) && isElectron) {
        dispatch(getOfflineLastOrderNumber(await getoffiledata("orderCount")));
        dispatch(
          activateOrderOffline({ orderType: type.key, orderTypeId: type.id }, username)
        );
      } else {
        dispatch(
          activateOrder({ orderType: type.key, orderTypeId: type.id }, username)
        );
      }
    }

    if (onSelectType) {
      onSelectType(type.id);
    }
  };

  return (
    <div className="d-flex justify-content-between p-2 bg-white type-selector">
      {orderTypes.map((type, index) => (
        <button
          key={type.id}
          className={`btn btn-sm d-flex align-items-center justify-content-center gap-1 py-1 w-100 mx-1 mobile-order-type-inactive`}
          onClick={() => handleTypeSelect(type, index)}
        >
          <i className={type.icon}></i>
          <span className="ml-1">{type.label}</span>
        </button>
      ))}
    </div>
  );
};

export default MobileOrderTypeSelector;
